import { createContext } from 'react'
import { XRayContext as XRayContextType } from '../../types/xRay'

const XRayContext = createContext<Partial<XRayContextType>>({})

export default XRayContext
